import { render, staticRenderFns } from "./ScytheResultsTable.vue?vue&type=template&id=649d8674&scoped=true"
import script from "./ScytheResultsTable.vue?vue&type=script&lang=ts"
export * from "./ScytheResultsTable.vue?vue&type=script&lang=ts"
import style0 from "./ScytheResultsTable.vue?vue&type=style&index=0&id=649d8674&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "649d8674",
  null
  
)

export default component.exports